var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.activeTab === "pending"
      ? _c("div", [
          _vm.isDesktop
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "md-table-toolbar" }, [
                    _c(
                      "div",
                      { staticClass: "flex justify-between" },
                      [
                        _c(
                          "md-field",
                          { staticStyle: { width: "30%" } },
                          [
                            _c("label", { attrs: { for: "pages-pending" } }, [
                              _vm._v("Per page"),
                            ]),
                            _c(
                              "md-select",
                              {
                                attrs: { name: "pages-pending" },
                                model: {
                                  value: _vm.pagination.perPage,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pagination, "perPage", $$v)
                                  },
                                  expression: "pagination.perPage",
                                },
                              },
                              _vm._l(
                                _vm.pagination.perPageOptions,
                                function (item) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: item,
                                      attrs: { label: item, value: item },
                                    },
                                    [_vm._v(_vm._s(item))]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "md-field",
                          { staticStyle: { width: "30%" } },
                          [
                            _c("md-input", {
                              staticClass: "mb-3",
                              staticStyle: { width: "200px" },
                              attrs: {
                                type: "search",
                                clearable: "",
                                placeholder: "Search invitations",
                              },
                              model: {
                                value: _vm.searchQueryModel,
                                callback: function ($$v) {
                                  _vm.searchQueryModel = $$v
                                },
                                expression: "searchQueryModel",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm.queriedData.length > 0
                    ? _c("md-table", {
                        staticClass:
                          "paginated-table table-striped table-hover",
                        attrs: {
                          value: _vm.queriedData,
                          "md-sort": _vm.currentSort,
                          "md-sort-order": _vm.currentSortOrder,
                          "md-sort-fn": _vm.customSort,
                        },
                        on: {
                          "update:mdSort": function ($event) {
                            _vm.currentSort = $event
                          },
                          "update:md-sort": function ($event) {
                            _vm.currentSort = $event
                          },
                          "update:mdSortOrder": function ($event) {
                            _vm.currentSortOrder = $event
                          },
                          "update:md-sort-order": function ($event) {
                            _vm.currentSortOrder = $event
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "md-table-row",
                              fn: function (ref) {
                                var item = ref.item
                                return _c(
                                  "md-table-row",
                                  {},
                                  [
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Company Name" } },
                                      [_vm._v(_vm._s(item.company))]
                                    ),
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Job Title" } },
                                      [_vm._v(_vm._s(item.job))]
                                    ),
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Status" } },
                                      [_vm._v(_vm._s(item.status))]
                                    ),
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Invited Date" } },
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-icon-inline" },
                                          [_vm._v("event")]
                                        ),
                                        _vm._v(" " + _vm._s(item.date) + " "),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Actions" } },
                                      [
                                        !item.responseStatus
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center",
                                                  "justify-content": "center",
                                                },
                                              },
                                              [
                                                _c(
                                                  "md-button",
                                                  {
                                                    staticClass:
                                                      "md-raised md-success",
                                                    staticStyle: {
                                                      width: "fit-content",
                                                      padding: "0 !important",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.$emit(
                                                          "open-accept-modal",
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" Accept ")]
                                                ),
                                                _c(
                                                  "md-button",
                                                  {
                                                    staticClass: "md-danger",
                                                    staticStyle: {
                                                      margin: "0 1rem",
                                                      width: "fit-content",
                                                      padding: "0 !important",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.$emit(
                                                          "reject",
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" Reject ")]
                                                ),
                                                _c(
                                                  "md-menu",
                                                  {
                                                    attrs: {
                                                      "md-direction":
                                                        "bottom-start",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "md-button",
                                                      {
                                                        staticClass:
                                                          "md-icon-button",
                                                        attrs: {
                                                          "md-menu-trigger": "",
                                                        },
                                                      },
                                                      [
                                                        _c("md-icon", [
                                                          _vm._v("more_vert"),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "md-menu-content",
                                                      [
                                                        _c(
                                                          "md-menu-item",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.viewJobDetails(
                                                                  item.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex items-center justify-center",
                                                              },
                                                              [
                                                                _c("md-icon", [
                                                                  _vm._v(
                                                                    "visibility"
                                                                  ),
                                                                ]),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    "View Job Details"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _c("div", [
                                              _c(
                                                "span",
                                                { staticClass: "confirmation" },
                                                [
                                                  _vm._v(
                                                    " You have " +
                                                      _vm._s(
                                                        item.responseStatus
                                                      ) +
                                                      " this invitation "
                                                  ),
                                                  item.rejectionReason
                                                    ? _c("span", [
                                                        _vm._v(
                                                          ": " +
                                                            _vm._s(
                                                              item.rejectionReason
                                                            )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(". "),
                                                ]
                                              ),
                                            ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          2623973710
                        ),
                      })
                    : _c("p", { staticClass: "empty-message" }, [
                        _vm._v("You have no job invitations at the moment."),
                      ]),
                ],
                1
              )
            : _c("div", [
                _vm.queriedData.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.queriedData, function (item) {
                        return _c(
                          "md-card",
                          { key: item.id, staticClass: "mb-3" },
                          [
                            _c("md-card-header", [
                              _c(
                                "div",
                                { staticClass: "flex justify-between" },
                                [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v(_vm._s(item.job)),
                                  ]),
                                  _c(
                                    "md-button",
                                    {
                                      staticClass:
                                        "md-success flex items-center justify-center",
                                      staticStyle: {
                                        padding: "0",
                                        height: "30px !important",
                                        "min-width": "0 !important",
                                        width: "40px !important",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewJobDetails(item.id)
                                        },
                                      },
                                    },
                                    [_c("md-icon", [_vm._v("visibility")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "md-subhead" }, [
                                _vm._v(_vm._s(item.company)),
                              ]),
                            ]),
                            _c("md-card-content", [
                              _c("p", [
                                _c("strong", [_vm._v("Status:")]),
                                _vm._v(" " + _vm._s(item.status)),
                              ]),
                              _c("p", [
                                _c("strong", [_vm._v("Date:")]),
                                _vm._v(" " + _vm._s(item.date)),
                              ]),
                              item.responseStatus
                                ? _c("p", [
                                    _c("strong", [_vm._v("Response:")]),
                                    _vm._v(
                                      " " + _vm._s(item.responseStatus) + " "
                                    ),
                                    item.rejectionReason
                                      ? _c("span", [
                                          _vm._v(
                                            " - " + _vm._s(item.rejectionReason)
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]),
                            !item.responseStatus
                              ? _c(
                                  "md-card-actions",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "md-raised md-success",
                                        staticStyle: {
                                          height: "30px !important",
                                          "margin-right": "1rem",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit(
                                              "open-accept-modal",
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" Accept ")]
                                    ),
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "md-danger",
                                        staticStyle: {
                                          height: "30px !important",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit("reject", item)
                                          },
                                        },
                                      },
                                      [_vm._v(" Reject ")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _c("p", { staticClass: "empty-message" }, [
                      _vm._v("You have no job invitations at the moment."),
                    ]),
              ]),
        ])
      : _vm._e(),
    _vm.activeTab === "previous"
      ? _c("div", [
          _vm.isDesktop
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "md-table-toolbar" }, [
                    _c(
                      "div",
                      { staticClass: "flex justify-between" },
                      [
                        _c(
                          "md-field",
                          { staticStyle: { width: "30%" } },
                          [
                            _c("label", { attrs: { for: "pages-pending" } }, [
                              _vm._v("Per page"),
                            ]),
                            _c(
                              "md-select",
                              {
                                attrs: { name: "pages-pending" },
                                model: {
                                  value: _vm.pagination.perPage,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pagination, "perPage", $$v)
                                  },
                                  expression: "pagination.perPage",
                                },
                              },
                              _vm._l(
                                _vm.pagination.perPageOptions,
                                function (item) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: item,
                                      attrs: { label: item, value: item },
                                    },
                                    [_vm._v(_vm._s(item))]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "md-field",
                          { staticStyle: { width: "30%" } },
                          [
                            _c("md-input", {
                              staticClass: "mb-3",
                              staticStyle: { width: "200px" },
                              attrs: {
                                type: "search",
                                clearable: "",
                                placeholder: "Search invitations",
                              },
                              model: {
                                value: _vm.searchQueryModel,
                                callback: function ($$v) {
                                  _vm.searchQueryModel = $$v
                                },
                                expression: "searchQueryModel",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm.queriedData.length > 0
                    ? _c("md-table", {
                        staticClass:
                          "paginated-table table-striped table-hover",
                        attrs: {
                          value: _vm.queriedData,
                          "md-sort": _vm.currentSort,
                          "md-sort-order": _vm.currentSortOrder,
                          "md-sort-fn": _vm.customSort,
                        },
                        on: {
                          "update:mdSort": function ($event) {
                            _vm.currentSort = $event
                          },
                          "update:md-sort": function ($event) {
                            _vm.currentSort = $event
                          },
                          "update:mdSortOrder": function ($event) {
                            _vm.currentSortOrder = $event
                          },
                          "update:md-sort-order": function ($event) {
                            _vm.currentSortOrder = $event
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "md-table-row",
                              fn: function (ref) {
                                var item = ref.item
                                return _c(
                                  "md-table-row",
                                  {},
                                  [
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Company Name" } },
                                      [_vm._v(_vm._s(item.company))]
                                    ),
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Job Name" } },
                                      [_vm._v(_vm._s(item.job))]
                                    ),
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Status" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "badge",
                                            class: {
                                              accepted:
                                                item.responseStatus ===
                                                "Accepted",
                                              rejected:
                                                item.responseStatus ===
                                                "Rejected",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.responseStatus))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "md-table-cell",
                                      {
                                        attrs: {
                                          "md-label": "Reason for Rejection",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.responseStatus === "Rejected"
                                                ? item.rejectionReason || "-"
                                                : "—"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Invited Date" } },
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-icon-inline" },
                                          [_vm._v("event")]
                                        ),
                                        _vm._v(" " + _vm._s(item.date) + " "),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "md-table-cell",
                                      { attrs: { "md-label": "Actions" } },
                                      [
                                        _c(
                                          "md-menu",
                                          {
                                            attrs: {
                                              "md-direction": "bottom-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass: "md-icon-button",
                                                attrs: {
                                                  "md-menu-trigger": "",
                                                },
                                              },
                                              [
                                                _c("md-icon", [
                                                  _vm._v("more_vert"),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "md-menu-content",
                                              [
                                                _c(
                                                  "md-menu-item",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.viewJobDetails(
                                                          item.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex items-center justify-center",
                                                      },
                                                      [
                                                        _c("md-icon", [
                                                          _vm._v("visibility"),
                                                        ]),
                                                        _c("span", [
                                                          _vm._v(
                                                            "View Job Details"
                                                          ),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          1649217661
                        ),
                      })
                    : _c("p", { staticClass: "empty-message" }, [
                        _vm._v("You haven’t responded to any invitations yet."),
                      ]),
                ],
                1
              )
            : _c("div", [
                _vm.queriedData.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.queriedData, function (item) {
                        return _c(
                          "md-card",
                          { key: item.id, staticClass: "mb-3" },
                          [
                            _c("md-card-header", [
                              _c("div", { staticClass: "md-title" }, [
                                _vm._v(_vm._s(item.job)),
                              ]),
                              _c("div", { staticClass: "md-subhead" }, [
                                _vm._v(_vm._s(item.company)),
                              ]),
                            ]),
                            _c("md-card-content", [
                              _c("p", [
                                _c("strong", [_vm._v("Status:")]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "badge",
                                    class: {
                                      accepted:
                                        item.responseStatus === "Accepted",
                                      rejected:
                                        item.responseStatus === "Rejected",
                                    },
                                    staticStyle: { "margin-left": "0.2rem" },
                                  },
                                  [_vm._v(_vm._s(item.responseStatus))]
                                ),
                              ]),
                              _c("p", [
                                _c("strong", [_vm._v("Rejection Reason:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.responseStatus === "Rejected"
                                        ? item.rejectionReason || "-"
                                        : "—"
                                    )
                                ),
                              ]),
                              _c("p", [
                                _c("strong", [_vm._v("Date:")]),
                                _vm._v(" " + _vm._s(item.date)),
                              ]),
                            ]),
                            _c(
                              "md-card-actions",
                              [
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-success flex items-center justify-center",
                                    staticStyle: {
                                      padding: "0",
                                      height: "30px !important",
                                      "min-width": "0 !important",
                                      width: "40px !important",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewJobDetails(item.id)
                                      },
                                    },
                                  },
                                  [_c("md-icon", [_vm._v("visibility")])],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _c("p", { staticClass: "empty-message" }, [
                      _vm._v("You haven’t responded to any invitations yet."),
                    ]),
              ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }